/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ActivityDto } from './ActivityDto';
import {
    ActivityDtoFromJSON,
    ActivityDtoFromJSONTyped,
    ActivityDtoToJSON,
} from './ActivityDto';

/**
 * 
 * @export
 * @interface ActivitiesDto
 */
export interface ActivitiesDto {
    /**
     * The activities.
     * @type {Array<ActivityDto>}
     * @memberof ActivitiesDto
     */
    items: Array<ActivityDto>;
    /**
     * The total number of activities.
     * @type {number}
     * @memberof ActivitiesDto
     */
    total: number;
}

/**
 * Check if a given object implements the ActivitiesDto interface.
 */
export function instanceOfActivitiesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function ActivitiesDtoFromJSON(json: any): ActivitiesDto {
    return ActivitiesDtoFromJSONTyped(json, false);
}

export function ActivitiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivitiesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ActivityDtoFromJSON)),
        'total': json['total'],
    };
}

export function ActivitiesDtoToJSON(value?: ActivitiesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ActivityDtoToJSON)),
        'total': value.total,
    };
}

